module.exports = __webpack_public_path__ + "img/Misc_CurlyBracket.619d9394.svg";